import React from 'react';
import { useTheme } from 'styled-components';
import NextImage, { StaticImageData } from 'next/image';

import CroppedWave from 'Public/graphics/waves/quote-block/wave-quote.svg';
import defaultProfileImage from 'Public/images/cards/profile/default.png';

import Grid, { Col } from 'Components/Grid';

import {
    WaveImage,
    ImageContainer,
    ImageWrapper,
    Background,
    LeftQuoteIcon,
    Quote,
    Container,
    Wrapper,
    Blockquote,
    QuoteWrapper
} from './Wave.styled';

export interface Props {
    image?: {
        src: StaticImageData | string;
        alt?: string;
    };
    quote: React.ReactNode | string;
    avatarBackgroundColor?: string;
    quoteColor?: string;
}

const Wave: React.FC<Props> = props => {
    const { colors } = useTheme();
    const {
        image,
        quote,
        avatarBackgroundColor = image?.src ? colors.tertiary.hex : colors.secondary.hex,
        quoteColor = colors.accents[6].hex
    } = props;

    return (
        <Wrapper>
            <Background>
                <WaveImage src={CroppedWave} alt="" width={1446} height={302} />
            </Background>
            <Grid>
                <Col m={[3, 13]} l={12}>
                    <Container>
                        <ImageContainer>
                            <ImageWrapper
                                $quoteColor={quoteColor}
                                $avatarBackgroundColor={avatarBackgroundColor}
                            >
                                <NextImage
                                    src={image?.src || defaultProfileImage}
                                    alt={image?.alt || ''}
                                    fill
                                    style={{ objectFit: 'cover' }}
                                />
                            </ImageWrapper>
                            <LeftQuoteIcon $quoteColor={quoteColor} />
                        </ImageContainer>
                        <QuoteWrapper>
                            <Blockquote>
                                <Quote $quoteColor={quoteColor}>{quote}</Quote>
                            </Blockquote>
                        </QuoteWrapper>
                    </Container>
                </Col>
            </Grid>
        </Wrapper>
    );
};

export default Wave;
